<script>
import { Line, mixins } from 'vue-chartjs'
// import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
const { reactiveProp } = mixins
// function random (min, max) {
//   return Math.floor(Math.random() * (max - min + 1) + min)
// }

export default {
  extends: Line,
  mixins: [ reactiveProp ],
  props: [ 'height', 'options', 'chartData' ],
  data () {
    return {
      labels: [],
      calls: [],
      minutes: []
    }
  },
  methods: {
    render () {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.render()
  }
}
</script>
